import { I18n } from '@calendly/i18n';
import { RadioInput } from '@calendly/ui/components/radio-input';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useMemo, forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isAvailableFeatureSelector } from 'features/billing/selectors';
const contentContainerIsPhoneCss = "c1b64nxr";
const contentContainerCss = "c13ign2i";
const ContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(contentContainerCss, {
    [contentContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const listContainerIsPhoneCss = "lad0ttm";
const listContainerIsSmallPhoneCss = "loyybav";
const listContainerCss = "l2osap";
const ListContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(listContainerCss, {
    [listContainerIsPhoneCss]: isPhone,
    [listContainerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const styledRadioInputCss = "sel8jb5";
const StyledRadioInput = forwardRef((props, ref) => <RadioInput ref={ref} {...props} className={classNames(styledRadioInputCss, props.className)} />);
const sideCapIsSelectedCss = "s1hex2jw";
const sideCapCss = "s1lqmko2";
const SideCap = forwardRef((props, ref) => {
  const {
    isSelected,
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(sideCapCss, {
    [sideCapIsSelectedCss]: isSelected
  }, props.className)} />;
});
const detailsCss = "d1rnb3p0";
const Details = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(detailsCss, props.className)} />;
});
const EventTypeInfo = ({
  duration,
  durationOptions,
  kindDescription,
  locationType,
  locationTypesCount = 0
}) => {
  const isMultipleDurationsAvailable = useSelector(state => isAvailableFeatureSelector(state, {
    featureKey: 'multiple_durations'
  }));
  const durationOptionsCount = durationOptions?.length;
  const locationInfo = useMemo(() => {
    if (!locationTypesCount) return null;
    if (locationTypesCount === 1) return I18n.t(`publisher.event_types.location.${locationType}.label`);
    return I18n.t('publisher.event_types.card.locations_count', {
      count: locationTypesCount
    });
  }, [locationType, locationTypesCount]);
  const durationInfo = useMemo(() => {
    const showSingleDuration = !isMultipleDurationsAvailable || !durationOptionsCount || durationOptionsCount < 2;
    if (showSingleDuration) {
      return duration;
    }
    return I18n.t('publisher.event_types.card.durations_count', {
      count: durationOptionsCount
    });
  }, [duration, durationOptionsCount, isMultipleDurationsAvailable]);
  const info = useMemo(() => [durationInfo, locationInfo, kindDescription].filter(Boolean).join(' • '), [durationInfo, locationInfo, kindDescription]);
  return <BodyText color="muted" size="medium">
      {info}
    </BodyText>;
};
const EventTypeItem = ({
  eventType,
  isSelected,
  onClick
}) => <label id={`event-type-label-${eventType.id}`}>
    <StyledRadioInput id={`event-type-${eventType.id}`} showControl={false} variant="selectable" checked={isSelected} onChange={() => onClick(eventType.id)} label={<>
          <SideCap color={eventType.color} isSelected={isSelected} />
          <Details>
            <BodyText weight="bold" size="large">{eventType.name}</BodyText>
            <EventTypeInfo duration={eventType.duration} durationOptions={eventType.durationOptions} kindDescription={eventType.kindDescription} locationType={eventType.locationType} locationTypesCount={eventType.locationTypesCount} />
          </Details>
        </>} />
  </label>;
export const EventTypeList = ({
  eventTypes,
  selectedEventTypeId,
  setSelectedEventTypeId
}) => <ContentContainer>
    <BodyText weight="bold">{I18n.t('publisher.billing.et_selection_modal.select_event_type')}</BodyText>
    <ListContainer>
      {eventTypes.map(eventType => <EventTypeItem key={eventType.id} eventType={eventType} isSelected={String(selectedEventTypeId) === String(eventType?.id)} onClick={setSelectedEventTypeId} />)}
    </ListContainer>
  </ContentContainer>;

require("./event_type_list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./event_type_list.js");